<template>
  <div>
    <div
      class="g-recaptcha"
      data-size="invisible"
      :data-sitekey="googleRecaptchaApiKey"
      data-action="login"
      data-callback="submitLoginForm"
    />
    <p class="page-heading">
      Regular, Non-Commercial, Commercial, and Motorcycle License Skills Testing
    </p>
    <!-- <v-alert
      border="top"
      text
      prominent
      color="info"
      type="info"
      elevation="2"
    >
      As of November 15, 2021, the SCDMV has returned to performing in-car
      road tests for regular licenses at all branch offices across the state.
    </v-alert>
    <v-alert
      border="top"
      text
      prominent
      color="warning"
      type="warning"
      elevation="2"
    >If you received your commercial learner's permit after February 7, 2022, you will need
    to completean FMCSA approved ELDT training program to be eligible to take the CDL Skills test.
    </v-alert> -->
    <p>Please complete the information below and submit the form to schedule an appointment.</p>

    <v-form ref="form" v-model="valid">
      <v-card class="pb-2 pt-4" elevation="2">
        <LoadingBusy
          :loading="loading"
          :isAuthenticating="true"
          text="Authenticating, please wait...">
        </LoadingBusy>
        <!-- <v-card-title class="justify-center">LOGIN</v-card-title> -->
        <v-card-text class="centerContainer">
          <v-row>
            <v-text-field
              v-model="dLNumber"
              label="SC Drivers License Number or Permit Number"
              prepend-inner-icon="mdi-card-account-details"
              filled
              dense
              required
              maxlength="9"
              :rules="[isValidDLNumber]"
              @keypress="isNumber($event)"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-select
              label="Test Type"
              prepend-inner-icon="mdi-car"
              filled
              :items="testTypes"
              item-text="Name"
              item-value="TestTypeCode"
              v-model="testType"
              dense
            ></v-select>
          </v-row>
          <v-row>
            <v-text-field
              v-model="firstName"
              type="text"
              inputmode="text"
              label="First Name"
              prepend-inner-icon="mdi-account"
              maxlength="20"
              :class="{ required: !firstName }"
              required
              filled
              dense
              :rules="[isValidFirstName]"
              @keypress="isLetterOrSpace($event)"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              v-model="lastName"
              type="text"
              label="Last Name"
              prepend-inner-icon="mdi-account"
              maxlength="30"
              required
              filled
              dense
              :rules="[isValidLastName]"
              @keypress="isLetterOrSpace($event)"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              v-model="dOB"
              label="Date of Birth"
              prepend-inner-icon="mdi-calendar-month"
              required
              filled
              dense
              :rules="[isValidDOB]"
              @keypress="isNumber($event)"
              @keyup="formatDateOfBirth($event)"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              v-model="email"
              label="Email"
              prepend-inner-icon="mdi-email"
              filled
              dense
              required
              :rules="[isValidEmail]"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              v-model="phone"
              type="text"
              label="Phone"
              prepend-inner-icon="mdi-phone"
              filled
              dense
              required
              maxlength="14"
              :rules="[isValidPhone]"
              @keypress="isNumber($event)"
              @input="formatPhoneNumber"
            ></v-text-field>
          </v-row>
        </v-card-text>
        <v-card-actions class="centerContainer">
          <v-btn
            class="justify-center"
            color="primary"
            height="45px"
            :disabled="!valid"
            block @click="login()">
            <v-icon>mdi-calendar-month</v-icon>
            Schedule Appointment
          </v-btn>
        </v-card-actions>
        <v-alert
          class="ma-2"
          type="error"
          :value="isLoginError"
          dense
          outlined
          dismissible
          transition="scale-transition"
        >
          {{ loginErrorMessage }}
        </v-alert>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NewBooking from '../models/NewBooking';
import scApi from '../api/scApi';
import LoadingBusy from '../components/LoadingBusy.vue';
import Common from '../models/Common';

export default {
  name: 'LoginPage',
  components: {
    LoadingBusy,
  },
  data() {
    return {
      valid: false,
      googleRecaptchaApiKey: process.env.VUE_APP_GOOGLE_RECAPTCHA_KEY,
      googleRecaptchaApiUrl: process.env.VUE_APP_GOOGLE_RECAPTCHA_ENDPOINT,
      loading: false,
      isLoginError: false,
      loginErrorMessage: '',
      firstName: '',
      lastName: '',
      dOB: '',
      dLNumber: '',
      email: '',
      phone: '',
      testType: 'D',
    };
  },
  computed: {
    ...mapGetters('userInfo', {
      dLNumberGetter: 'dLNumber',
      firstNameGetter: 'firstName',
      lastNameGetter: 'lastName',
      dateOfBirthGetter: 'dateOfBirth',
      testTypeGetter: 'testType',
      phoneGetter: 'phone',
      emailGetter: 'email',
    }),
    testTypes() {
      return this.$store.getters.serviceTypes;
    },
    testtypetext() {
      return Common.GetTestTypeText(this.testType);
    },
    testtypeid() {
      return Common.GettTestTypeId(this.testType);
    },
  },
  mounted() {
    // next line places reCAPTCHA callback in global scope
    // (outside of Vue) for Google reCAPTCHA API callback
    window.submitLoginForm = this.submitLoginForm;

    const recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', this.googleRecaptchaApiUrl);
    document.head.appendChild(recaptchaScript);
    this.dLNumber = this.dLNumberGetter;
    this.testType = this.testTypeGetter;
    this.firstName = this.firstNameGetter;
    this.lastName = this.lastNameGetter;
    this.dOB = this.dateOfBirthGetter;
    this.email = this.emailGetter;
    this.phone = this.phoneGetter;
  },
  methods: {
    ...mapActions('userInfo', {
      dLNumberAction: 'dLNumber',
      firstNameAction: 'firstName',
      lastNameAction: 'lastName',
      dateOfBirthAction: 'dateOfBirth',
      testTypeAction: 'testType',
      testTypeTextAction: 'testTypeText',
      testTypeIdtAction: 'testTypeId',
      phoneAction: 'phone',
      emailAction: 'email',
    }),
    ...mapActions(['beginDate', 'endDate', 'responseID']),
    ...mapActions(['existingAppointment', 'isNewServiceType', 'booking']),
    ...mapActions('bookingDetails', {
      siteNameAction: 'siteName',
      siteAddressAction: 'siteAddress',
      confirmationNumberAction: 'confirmationNumber',
      formattedCheckinDateTimeAction: 'formattedCheckinDateTime',
      serviceTypeAction: 'serviceType',
      serviceTypeTextAction: 'serviceTypeText',
      serviceTypeIdAction: 'serviceTypeId',
    }),
    ...mapActions(['isLogIn']),
    nextPage() {
      this.$emit('navigateTo', 'LandingPage');
    },
    login() {
      // this.$emit('navigateTo', 'LandingPage');
      // eslint-disable-next-line no-undef
      grecaptcha.enterprise.execute();
      console.log('login');
    },
    async submitLoginForm(reCAPTCHAtoken) {
      // console.log('submitLoginForm');
      // console.log(reCAPTCHAtoken);
      this.loading = true;
      this.isLoginError = false;
      try {
        const response = await scApi.Auth(
          this.firstName,
          this.lastName,
          this.dOB,
          this.dLNumber,
          this.testType,
          reCAPTCHAtoken,
        );

        // auth succeeded
        this.dLNumberAction({ value: this.dLNumber });
        this.firstNameAction({ value: this.firstName });
        this.lastNameAction({ value: this.lastName });
        this.dateOfBirthAction({ value: this.dOB });
        this.testTypeAction({ value: this.testType });
        this.testTypeTextAction({ value: this.testtypetext });
        this.testTypeIdtAction({ value: this.testtypeid });
        this.phoneAction({ value: this.phone });
        this.emailAction({ value: this.email });
        console.log(this.testType);
        console.log(this.testtypetext);
        console.log(this.testtypeid);
        console.log(this.$store.state.userInfo.FirstName);
        NewBooking.GetFirstName();
        NewBooking.GetLastName();
        NewBooking.GetDateOfBirth();
        console.log(response.ErrorCode);
        console.log(response.ErrorMessage);
        console.log(response.Message);
        console.log(response.BeginDate);
        console.log(response.EndDate);
        console.log(response.IsEligible);
        console.log(response.ResponseID);
        if (response.IsEligible) {
          this.beginDate({ value: response.BeginDate });
          this.endDate({ value: response.EndDate });
          this.responseID({ value: response.ResponseID });
          NewBooking.GetBeginDate();
          NewBooking.GetEndDate();
          NewBooking.GetResponseID();
          try {
            const responseBooking = await scApi.GetBooking(
              this.firstName,
              this.lastName,
              this.dOB,
              this.dLNumber,
            );
            if (responseBooking.length === 0) {
              this.existingAppointment({ value: false });
            } else {
              // Do we need to ensure there is only 1 booking?
              this.existingAppointment({ value: true });
              this.booking({ value: responseBooking });
              this.siteNameAction({ value: responseBooking[0].SiteName });
              this.siteAddressAction({ value: responseBooking[0].SiteAddress });
              this.confirmationNumberAction({ value: responseBooking[0].ConfirmationNumber });
              this.formattedCheckinDateTimeAction({
                value: responseBooking[0].FormattedBookingDateTime,
              });
              const serviceTypeText = responseBooking[0].ServiceType;
              this.serviceTypeTextAction({ value: serviceTypeText });
              const serviceType = Common.GetTestType(serviceTypeText);
              this.serviceTypeAction({ value: serviceType });
              this.serviceTypeIdAction({
                value: Common.GettTestTypeId(serviceType),
              });
              if (serviceType !== this.testType) {
                this.isNewServiceType({ value: true });
              }
            }
            this.isLogIn({ value: true });
            console.log(this.$store.getters.existingAppointment);
            console.log(this.$store.getters.booking);
            console.log(this.$store.state.bookingDetails.ServiceType);
            console.log(this.$store.state.bookingDetails.ServiceTypeText);
            console.log(this.$store.state.bookingDetails.ServiceTypeId);
          } catch (error) {
            console.log(error);
            this.isLoginError = true;
            this.loginErrorMessage = error;
          } finally {
            console.log('Inside GetBooking finally');
          }
          this.$emit('navigateTo', 'LandingPage', response);
        } else {
          this.isLoginError = true;
          this.loginErrorMessage = response.Message || response.ErrorMessage;
        }
      } catch (error) {
        // auth failed
        // console.log(error);
        this.isLoginError = true;
        if (!error.response) {
          // You'll get here if the Azure function does not respond
          this.loginErrorMessage = 'Communication error, please try again.';
        } else {
          // Else log the error message/authentication issue returned from web service
          this.loginErrorMessage = error.response.message;
        }
      } finally {
        this.loading = false;
      }
    },
    isLetterOrSpace(e) {
      const char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z ]+$/.test(char)) {
        return true;
      }
      return e.preventDefault();
    },
    isNumber(e) {
      if (e.keyCode >= 48 && e.keyCode <= 57) {
        // Number
        return true;
      }
      return e.preventDefault();
    },
    isValidFirstName(value) {
      if (!value || value.includes('  ')) {
        return 'First name is required';
      }
      const firstChar = value[0];
      if (firstChar === ' ') {
        return 'First name is required';
      }
      return true;
    },
    isValidLastName(value) {
      if (!value || value.includes('  ')) {
        return 'Last name is required';
      }
      const firstChar = value[0];
      if (firstChar === ' ') {
        return 'Last name is required';
      }
      return true;
    },
    isValidDOB(value) {
      const dateParts = value.split('/');
      if (!value) {
        return 'Date of birth is required';
      }
      if (
        !/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(18[9][0-9]|19[0-9][0-9]|2[0-9][0-9][0-9])$/.test(
          value,
        )
      ) {
        return 'Invalid Date of Birth';
      }
      if (dateParts.length === 3) {
        const dob = new Date(value);
        if (dob >= new Date()) {
          return 'Invalid Date of Birth';
        }
      }
      return true;
    },
    formatDateOfBirth(evt) {
      let dob = this.dOB;
      const charCode = evt.which ? evt.which : evt.keyCode;

      if (charCode !== 193 && charCode !== 111) {
        if (charCode !== 8) {
          if (dob.match(/^\d{2}$/) !== null) {
            dob += '/';
          } else if (dob.match(/^\d{2}\/\d{2}$/)) {
            dob += '/';
          }
        } else {
          const temp = dob;
          if (dob.match(/^\d{2}\/\d{2}$/)) {
            dob = temp.substring(0, 4);
          } else if (dob.match(/^\d{2}$/)) {
            dob = temp.substring(0, 1);
          }
        }
      } else {
        const temp = dob;
        const tam = dob.length;
        dob = temp.substring(0, tam - 1);
      }
      this.dOB = dob;
    },
    formatPhoneNumber() {
      const x = this.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      // eslint-disable-next-line prefer-template
      this.phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    },
    isValidEmail(value) {
      if (!value) {
        return 'Email address is required';
      }
      // eslint-disable-next-line no-useless-escape
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!regex.test(value)) {
        return 'Invalid email address';
      }
      return true;
    },
    isValidPhone(value) {
      if (!value) {
        return 'Phone number is required';
      }
      if (value.length < 14) {
        return 'Invalid phone number';
      }
      return true;
    },
    isValidDLNumber(value) {
      if (!value) {
        return 'Driver License number or Permit number is required';
      }
      // if (value.length < 9) {
      //   return 'Invalid driver license number or permit number';
      // }
      return true;
    },
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
